var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.72266,10c-7.162,0 -7.72266,0.56066 -7.72266,7.72266v14.55469c0,7.162 0.56066,7.72266 7.72266,7.72266h14.55469c7.162,0 7.72266,-0.56066 7.72266,-7.72266v-14.50781c0,-7.206 -0.56353,-7.76953 -7.76953,-7.76953zM17,11h16c5.565,0 6,0.435 6,6v16c0,5.565 -0.435,6 -6,6h-16c-5.565,0 -6,-0.435 -6,-6v-16c0,-5.565 0.435,-6 6,-6zM26.01367,15.76953v12.66602c0,1.741 -1.51456,2.64063 -2.60156,2.64063c-0.819,0 -2.67969,-0.64016 -2.67969,-2.66016c0,-2.12 1.73817,-2.66016 2.70117,-2.66016c0.56,0 0.7793,0.11914 0.7793,0.11914v-3.37891c0,0 -0.42039,-0.0625 -0.90039,-0.0625c-3.449,0 -5.90234,2.79042 -5.90234,5.98242c0,2.697 2.10989,5.96289 5.96289,5.96289c4.104,0 5.98242,-3.42336 5.98242,-5.94336v-6.2832c0,0 1.8302,1.28125 4.2832,1.28125v-3.20117c-2.813,-0.201 -4.31788,-2.09089 -4.42187,-4.46289z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktokIcon.6c40bfafdd6a1d2ff57ea18ceb26cb5d.svg";
export { ForwardRef as ReactComponent };